import { IChartContainer } from "../models/base/chart-container.interface";
import { IChartDataService } from "../models/base/chart-data-service.interface";
import { CurrentPositionDataModel } from "../models/pnl/current-position-data.model";
import { PnlDataModel } from "../models/pnl/pnl-data.model";
import { IComponent } from "./component.interface";

export class PnlComponent implements IComponent {
    public id = '';

    public element: HTMLElement;
    private chartService: IChartDataService;

    private pnlData = new PnlDataModel();
    private currentPositions: Array<CurrentPositionDataModel> = [];

    constructor(el: HTMLElement, base: IChartContainer) {
        this.element = el;
        this.chartService = base.chartService;
        this.subscribeChartDataService();
    }
    
    public hideElements() {
        this.hideCurrentPositionElement();
        this.hidePnlDataElement();
    }

    private subscribeChartDataService() {
        this.subscribePnlData();
        this.subscribeCurrentPositionData();
    }
    
    private subscribePnlData() {
        this.chartService.subscribePnlData((pnlData: any) => this.updatePnlData(pnlData));
    }

    private subscribeCurrentPositionData() {
        this.chartService.subscribeCurrentPositionData((currentPositionData: any) => this.updateCurrentPositionData(currentPositionData));
    }
    
    private hidePnlDataElement() {
        const pnlDiv = this.element.findFirst('.pnl');
        pnlDiv?.addClass('hidden');
    }

    private showPnlDataElement() {
        const pnlDiv = this.element.findFirst('.pnl');
        pnlDiv?.removeClass('hidden');
    }

    private updatePnlData(pnlData: PnlDataModel) {
        const pnlDiv = this.element.findFirst('.pnl');

        this.pnlData = pnlData;

        if (this.pnlData.doesNotHaveValue()) {
            this.hidePnlDataElement();
            return;
        }

        this.showPnlDataElement();
        pnlDiv?.setInnerHtml(this.pnlData.pnlText);
        pnlDiv?.setAttribute("style", `color:${pnlData.pnLColor}`);
    }

    private hideCurrentPositionElement() {
        this.element.findFirst('.current-position-wrapper')?.setInnerHtml('');
    }

    private updateCurrentPositionData(currentPositionAny: Array<CurrentPositionDataModel>) {
        this.currentPositions = currentPositionAny;

        if (!this.currentPositions.length) {
            this.hideCurrentPositionElement();
        }

        let html = '';
        for (const currentPosition of this.currentPositions) {
            if (currentPosition.doesNotHaveValue()) {
                continue;
            }

            html += currentPosition.toHtml();
        }

        this.element.findFirst('.current-position-wrapper')?.setInnerHtml(html);
    }
}
